import { cronosClient } from "@/config/client"

type ProductTourStatus = "completed" | "skipped" | null

interface UpdateProductTourStatusParams {
  status: ProductTourStatus
}

export function updateProductTourStatus(data: UpdateProductTourStatusParams) {
  return cronosClient.put("/v1/user/product-tour", data)
}
